import { useCallback } from 'react';
import SearchField from 'components/Field/SearchField/SearchField';
import Portal from 'components/Portal/Portal';
import FiltersBar from 'components/FiltersBar/FiltersBar';
import MarketplaceFilter from 'components/MarketplaceFilter/MarketplaceFilter';
import useFilters from 'hooks/useFilters';
import { useMarketplaces } from 'hooks/redux/useMarketplaces';

export default function MarketplacePendingOrdersFiltersBar({
  query,
  onChangeQuery = () => {},
  onFiltersChange = () => {},
}) {
  const { marketplaces } = useMarketplaces();
  const [filters, setFilters] = useFilters(
    'marketplacePendingOrdersFilters',
    onFiltersChange,
    {
      marketplace: marketplaces[0]?.id,
    },
  );

  const updateMarketplace = useCallback(
    (event, { value }) => {
      const marketplace = marketplaces.find(
        (marketplace) => marketplace.id === value,
      )?.name;
      setFilters({ ...filters, marketplace });
    },
    [filters, setFilters, marketplaces],
  );

  return (
    <FiltersBar>
      <Portal.In target="page-header-right">
        <SearchField
          value={query}
          placeholder="Buscar…"
          onChange={onChangeQuery}
        />
      </Portal.In>
      <MarketplaceFilter
        clearable={false}
        currentMarketplace={
          marketplaces.find(
            (marketplace) => marketplace.name === filters?.marketplace,
          )?.id
        }
        onChangeMarketplace={updateMarketplace}
      />
    </FiltersBar>
  );
}
